var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.$style.card,style:(_vm.backgroundStyle),attrs:{"to":'/categories/'+_vm.category.id}},[_c('h3',{class:_vm.$style.heading},[_vm._v(_vm._s(_vm.category.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }